var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{ scrolled: _vm.isScrolled, 'simple-layout': _vm.simpleLayout },attrs:{"id":"app"}},[_c('navbar',{ref:"navbar",class:[{ 'home-nav' : _vm.$route.name == 'home' }, _vm.navbarAnimation],attrs:{"simple-nav":_vm.simpleLayout}}),_c('router-view',{}),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }